import "../assets/index-ffa6d11c.css";
import { r as c } from "../chunks/index-5f2a5f57.mjs";
import { N as rt } from "../chunks/index-5f2a5f57.mjs";
import { generateUrl as p } from "@nextcloud/router";
import { n as u } from "../chunks/_plugin-vue2_normalizer-71e2aa87.mjs";
import { t as o } from "../chunks/l10n-ef44019c.mjs";
import "../Directives/Tooltip.mjs";
import { emojiAddRecent as m, emojiSearch as d } from "../Functions/emoji.mjs";
import { n as h, j as f } from "../chunks/referencePickerModal-c2f33569.mjs";
import "@nextcloud/axios";
import "unist-util-visit";
import "unist-builder";
import "unified";
import "remark-parse";
import "remark-breaks";
import "remark-rehype";
import "rehype-react";
import "rehype-external-links";
import "./NcEmptyContent.mjs";
import "./NcSelect.mjs";
import "./NcLoadingIcon.mjs";
import "./NcTextField.mjs";
import "./NcButton.mjs";
import "./NcModal.mjs";
import "@nextcloud/event-bus";
import l from "tributejs/dist/tribute.esm.js";
import _ from "debounce";
import g from "string-length";
import { VTooltip as b } from "floating-vue";
const y = {
  name: "NcAutoCompleteResult",
  props: {
    title: {
      type: String,
      required: !0
    },
    subline: {
      type: String,
      default: null
    },
    id: {
      type: String,
      default: null
    },
    icon: {
      type: String,
      required: !0
    },
    iconUrl: {
      type: String,
      default: null
    },
    source: {
      type: String,
      required: !0
    },
    status: {
      type: [Object, Array],
      default: () => ({})
    }
  },
  computed: {
    avatarUrl() {
      return this.iconUrl ? this.iconUrl : this.id && this.source === "users" ? this.getAvatarUrl(this.id, 44) : null;
    },
    haveStatus() {
      var e, t, n;
      return ((e = this.status) == null ? void 0 : e.icon) || ((t = this.status) == null ? void 0 : t.status) && ((n = this.status) == null ? void 0 : n.status) !== "offline";
    }
  },
  methods: {
    getAvatarUrl(e, t) {
      return p("/avatar/{user}/{size}", {
        user: e,
        size: t
      });
    }
  }
};
var C = function() {
  var t = this, n = t._self._c;
  return n("div", { staticClass: "autocomplete-result" }, [n("div", { staticClass: "autocomplete-result__icon", class: [t.icon, `autocomplete-result__icon--${t.avatarUrl ? "with-avatar" : ""}`], style: t.avatarUrl ? { backgroundImage: `url(${t.avatarUrl})` } : null }, [t.haveStatus ? n("div", { staticClass: "autocomplete-result__status", class: [`autocomplete-result__status--${t.status && t.status.icon ? "icon" : t.status.status}`] }, [t._v(" " + t._s(t.status && t.status.icon || "") + " ")]) : t._e()]), n("span", { staticClass: "autocomplete-result__content" }, [n("span", { staticClass: "autocomplete-result__title", attrs: { title: t.title } }, [t._v(" " + t._s(t.title) + " ")]), t.subline ? n("span", { staticClass: "autocomplete-result__subline" }, [t._v(" " + t._s(t.subline) + " ")]) : t._e()])]);
}, v = [], k = /* @__PURE__ */ u(
  y,
  C,
  v,
  !1,
  null,
  "25cf09d8",
  null,
  null
);
const x = k.exports;
const T = {
  name: "NcRichContenteditable",
  directives: {
    tooltip: b
  },
  mixins: [c],
  props: {
    value: {
      type: String,
      default: "",
      required: !0
    },
    placeholder: {
      type: String,
      default: o("Write a message …")
    },
    autoComplete: {
      type: Function,
      default: () => []
    },
    menuContainer: {
      type: Element,
      default: () => document.body
    },
    /**
     * Make the contenteditable looks like a textarea or not.
     * Default looks like a single-line input.
     * This also handle the default enter/shift+enter behaviour.
     * if multiline, enter = newline; otherwise enter = submit
     * shift+enter always add a new line. ctrl+enter always submits
     */
    multiline: {
      type: Boolean,
      default: !1
    },
    /**
     * Is the content editable ?
     */
    contenteditable: {
      type: Boolean,
      default: !0
    },
    /**
     * Disable the editing and show specific disabled design
     */
    disabled: {
      type: Boolean,
      default: !1
    },
    /**
     * Max allowed length
     */
    maxlength: {
      type: Number,
      default: null
    },
    /**
     * Enable or disable emoji autocompletion
     */
    emojiAutocomplete: {
      type: Boolean,
      default: !0
    },
    /**
     * Enable or disable link autocompletion
     */
    linkAutocomplete: {
      type: Boolean,
      default: !0
    }
  },
  emits: [
    "submit",
    "paste",
    "update:value",
    "smart-picker-submit"
  ],
  data() {
    return {
      textSmiles: [],
      tribute: null,
      autocompleteOptions: {
        // Allow spaces in the middle of mentions
        allowSpaces: !0,
        fillAttr: "id",
        // Search against id and title (display name)
        lookup: (e) => `${e.id} ${e.title}`,
        // Where to inject the menu popup
        menuContainer: this.menuContainer,
        // Popup mention autocompletion templates
        menuItemTemplate: (e) => this.renderComponentHtml(e.original, x),
        // Hide if no results
        noMatchTemplate: () => '<span class="hidden"></span>',
        // Inner display of mentions
        selectTemplate: (e) => {
          var t;
          return this.genSelectTemplate((t = e == null ? void 0 : e.original) == null ? void 0 : t.id);
        },
        // Autocompletion results
        values: this.debouncedAutoComplete
      },
      emojiOptions: {
        trigger: ":",
        // Don't use the tribute search function at all
        // We pass search results as values (see below)
        lookup: (e, t) => t,
        // Where to inject the menu popup
        menuContainer: this.menuContainer,
        // Popup mention autocompletion templates
        menuItemTemplate: (e) => this.textSmiles.includes(e.original) ? e.original : `<span class="tribute-container-emoji__item__emoji">${e.original.native}</span> :${e.original.short_name}`,
        // Hide if no results
        noMatchTemplate: () => o("No emoji found"),
        // Display raw emoji along with its name
        selectTemplate: (e) => this.textSmiles.includes(e.original) ? e.original : (m(e.original), e.original.native),
        // Pass the search results as values
        values: (e, t) => {
          const n = d(e);
          this.textSmiles.includes(":" + e) && n.unshift(":" + e), t(n);
        },
        // Class added to the menu container
        containerClass: "tribute-container-emoji",
        // Class added to each list item
        itemClass: "tribute-container-emoji__item"
      },
      linkOptions: {
        trigger: "/",
        // Don't use the tribute search function at all
        // We pass search results as values (see below)
        lookup: (e, t) => t,
        // Where to inject the menu popup
        menuContainer: this.menuContainer,
        // Popup mention autocompletion templates
        menuItemTemplate: (e) => `<img class="tribute-container-link__item__icon" src="${e.original.icon_url}"> <span class="tribute-container-link__item__title">${e.original.title}</span>`,
        // Hide if no results
        noMatchTemplate: () => o("No link provider found"),
        selectTemplate: this.getLink,
        // Pass the search results as values
        values: (e, t) => t(h(e)),
        // Class added to the menu container
        containerClass: "tribute-container-link",
        // Class added to each list item
        itemClass: "tribute-container-link__item"
      },
      // Represent the raw untrimmed text of the contenteditable
      // serves no other purpose than to check whether the
      // content is empty or not
      localValue: this.value,
      // Is in text composition session in IME
      isComposing: !1
    };
  },
  computed: {
    /**
     * Is the current trimmed value empty?
     *
     * @return {boolean}
     */
    isEmptyValue() {
      return !this.localValue || this.localValue && this.localValue.trim() === "";
    },
    /**
     * Is this Firefox? 🙄
     *
     * @return {boolean}
     */
    isFF() {
      return !!navigator.userAgent.match(/firefox/i);
    },
    /**
     * Is the current value over maxlength?
     *
     * @return {boolean}
     */
    isOverMaxlength() {
      return this.isEmptyValue || !this.maxlength ? !1 : g(this.localValue) > this.maxlength;
    },
    /**
     * Tooltip to show if characters count is over limit
     *
     * @return {string}
     */
    tooltipString() {
      return this.isOverMaxlength ? {
        content: o("Message limit of {count} characters reached", { count: this.maxlength }),
        shown: !0,
        trigger: "manual"
      } : null;
    },
    /**
     * Edit is only allowed when contenteditableis true and disabled is false
     *
     * @return {boolean}
     */
    canEdit() {
      return this.contenteditable && !this.disabled;
    },
    /**
     * Proxied native event handlers without custom event handlers
     *
     * @return {Record<string, Function>}
     */
    listeners() {
      const e = { ...this.$listeners };
      return delete e.paste, e;
    }
  },
  watch: {
    /**
     * If the parent value change, we compare the plain text rendering
     * If it's different, we render everything and update the main content
     */
    value() {
      const e = this.$refs.contenteditable.innerHTML;
      this.value.trim() !== this.parseContent(e).trim() && this.updateContent(this.value);
    }
  },
  mounted() {
    const e = ["d", "D", "p", "P", "s", "S", "x", "X", ")", "(", "|", "/"];
    this.textSmiles = [], e.forEach((t) => {
      this.textSmiles.push(":" + t), this.textSmiles.push(":-" + t);
    }), this.autocompleteTribute = new l(this.autocompleteOptions), this.autocompleteTribute.attach(this.$el), this.emojiAutocomplete && (this.emojiTribute = new l(this.emojiOptions), this.emojiTribute.attach(this.$el)), this.linkAutocomplete && (this.linkTribute = new l(this.linkOptions), this.linkTribute.attach(this.$el)), this.updateContent(this.value), this.$refs.contenteditable.contentEditable = this.canEdit;
  },
  beforeDestroy() {
    this.autocompleteTribute && this.autocompleteTribute.detach(this.$el), this.emojiTribute && this.emojiTribute.detach(this.$el), this.linkTribute && this.linkTribute.detach(this.$el);
  },
  methods: {
    /**
     * Focus the richContenteditable
     *
     * @public
     */
    focus() {
      this.$refs.contenteditable.focus();
    },
    getLink(e) {
      return f(e.original.id).then((t) => {
        const n = document.getElementById("tmp-smart-picker-result-node"), i = {
          result: t,
          insertText: !0
        };
        if (this.$emit("smart-picker-submit", i), i.insertText) {
          const s = document.createTextNode(t);
          n.replaceWith(s), this.setCursorAfter(s), this.updateValue(this.$refs.contenteditable.innerHTML);
        } else
          n.remove();
      }).catch((t) => {
        console.debug("Smart picker promise rejected:", t);
        const n = document.getElementById("tmp-smart-picker-result-node");
        this.setCursorAfter(n), n.remove();
      }), '<span id="tmp-smart-picker-result-node"></span>';
    },
    setCursorAfter(e) {
      const t = document.createRange();
      t.setEndAfter(e), t.collapse();
      const n = window.getSelection();
      n.removeAllRanges(), n.addRange(t);
    },
    /**
     * Re-emit the input event to the parent
     *
     * @param {Event} event the input event
     */
    onInput(e) {
      this.updateValue(e.target.innerHTML);
    },
    /**
     * When pasting, sanitize the content, extract text
     * and render it again
     *
     * @param {Event} event the paste event
     * @fires Event paste the original paste event
     */
    onPaste(e) {
      if (!this.canEdit)
        return;
      e.preventDefault();
      const t = e.clipboardData;
      if (this.$emit("paste", e), t.files.length !== 0 || !Object.values(t.items).find((a) => a == null ? void 0 : a.type.startsWith("text")))
        return;
      const n = t.getData("text"), i = window.getSelection();
      if (!i.rangeCount) {
        this.updateValue(n);
        return;
      }
      const s = i.getRangeAt(0);
      i.deleteFromDocument(), s.insertNode(document.createTextNode(n));
      const r = document.createRange();
      r.setStart(e.target, s.endOffset), r.collapse(!0), i.removeAllRanges(), i.addRange(r), this.updateValue(this.$refs.contenteditable.innerHTML);
    },
    /**
     * Update the value text from the provided html
     *
     * @param {string} htmlOrText the html content (or raw text with @mentions)
     */
    updateValue(e) {
      const t = this.parseContent(e);
      this.localValue = t, this.$emit("update:value", t);
    },
    /**
     * Update content and local value
     *
     * @param {string} value the message value
     */
    updateContent(e) {
      const t = this.renderContent(e);
      this.$refs.contenteditable.innerHTML = t, this.localValue = e;
    },
    /**
     * Because FF have a decade old bug preventing contenteditable=false
     * to properly be deleted on backspace, we have to hack 👀
     * https://stackoverflow.com/a/59383394/3885878
     * https://stackoverflow.com/a/30574622
     *
     * @param {Event} event the delete keydown event
     */
    onDelete(e) {
      if (!this.isFF || !window.getSelection || !this.canEdit)
        return;
      const t = window.getSelection(), n = e.target;
      if (!t.isCollapsed || !t.rangeCount)
        return;
      const i = t.getRangeAt(t.rangeCount - 1);
      if (i.commonAncestorContainer.nodeType === 3 && i.startOffset > 0)
        return;
      const s = document.createRange();
      if (t.anchorNode !== n)
        s.selectNodeContents(n), s.setEndBefore(t.anchorNode);
      else if (t.anchorOffset > 0)
        s.setEnd(n, t.anchorOffset);
      else
        return;
      s.setStart(n, s.endOffset - 1);
      const r = s.cloneContents().lastChild;
      r && r.contentEditable === "false" && (s.deleteContents(), e.preventDefault());
    },
    /**
     * Enter key pressed. Submits if not multiline
     *
     * @param {Event} event the keydown event
     */
    onEnter(e) {
      this.multiline || this.isOverMaxlength || this.autocompleteTribute.isActive || this.emojiTribute.isActive || this.linkTribute.isActive || this.isComposing || (e.preventDefault(), e.stopPropagation(), this.$emit("submit", e));
    },
    /**
     * Ctrl + Enter key pressed is used to submit
     *
     * @param {Event} event the keydown event
     */
    onCtrlEnter(e) {
      this.isOverMaxlength || this.$emit("submit", e);
    },
    /**
     * Debounce the autocomplete function
     */
    debouncedAutoComplete: _(async function(e, t) {
      this.autoComplete(e, t);
    }, 100),
    onKeyUp(e) {
      e.stopImmediatePropagation();
    }
  }
};
var S = function() {
  var t = this, n = t._self._c;
  return n("div", t._g({ directives: [{ name: "tooltip", rawName: "v-tooltip", value: t.tooltipString, expression: "tooltipString" }], ref: "contenteditable", staticClass: "rich-contenteditable__input", class: {
    "rich-contenteditable__input--empty": t.isEmptyValue,
    "rich-contenteditable__input--multiline": t.multiline,
    "rich-contenteditable__input--overflow": t.isOverMaxlength,
    "rich-contenteditable__input--disabled": t.disabled
  }, attrs: { contenteditable: t.canEdit, "aria-placeholder": t.placeholder, "aria-multiline": "true", role: "textbox" }, on: { input: t.onInput, compositionstart: function(i) {
    t.isComposing = !0;
  }, compositionend: function(i) {
    t.isComposing = !1;
  }, keydown: [function(i) {
    return !i.type.indexOf("key") && t._k(i.keyCode, "delete", [8, 46], i.key, ["Backspace", "Delete", "Del"]) ? null : t.onDelete.apply(null, arguments);
  }, function(i) {
    return !i.type.indexOf("key") && t._k(i.keyCode, "enter", 13, i.key, "Enter") || i.ctrlKey || i.shiftKey || i.altKey || i.metaKey ? null : t.onEnter.apply(null, arguments);
  }, function(i) {
    return !i.type.indexOf("key") && t._k(i.keyCode, "enter", 13, i.key, "Enter") || !i.ctrlKey || i.shiftKey || i.altKey || i.metaKey ? null : (i.stopPropagation(), i.preventDefault(), t.onCtrlEnter.apply(null, arguments));
  }], paste: t.onPaste, "!keyup": function(i) {
    return i.stopPropagation(), i.preventDefault(), t.onKeyUp.apply(null, arguments);
  } } }, t.listeners));
}, A = [], E = /* @__PURE__ */ u(
  T,
  S,
  A,
  !1,
  null,
  "9e395f41",
  null,
  null
);
const it = E.exports;
export {
  x as NcAutoCompleteResult,
  rt as NcMentionBubble,
  it as default
};
